<template lang="pug">
  div.n-accordion-chart
    n-accordion(
      v-for="(item, index) in items"
      :key="index"
      :readonly="!item.children || !item.children.length"
    )
      template(slot="header")
        n-accordion-chart-header(
          :color="getBarColor(index)"
          :label="item.label"
          :percent="item.percent"
          :max-percent="getMaxPercent(items)"
          :value="item.value"
          :info-text="item.info_text"
          :isDecimal="isDecimal"
        )

      template(v-if="item.children" slot="content")
        n-accordion.highlighted(
          v-for="(item_, index_) in item.children"
          :key="index_"
          :readonly="!item_.children || !item_.children.length"
        )
          template(slot="header")
            n-accordion-chart-header(
              :parent-color="getBarColor(index)"
              :color="getBarColor(index, index_)"
              :label="item_.label"
              :percent="item_.percent"
              :max-percent="getMaxPercent(item.children)"
              :value="item_.value"
              :is-child="true"
              :info-text="item_.info_text"
              :isDecimal="isDecimal"
            )

          template(v-if="item_.children" slot="content")
            n-accordion(
              v-for="(item__, index__) in item_.children"
              :key="index__"
              :readonly="!item__.children || !item__.children.length"
            )
              template(slot="header")
                n-accordion-chart-header(
                  :color="getBarColor(index, index_, index__)"
                  :back-color="'#e9e9e9'"
                  :label="item__.label"
                  :percent="item__.percent"
                  :max-percent="getMaxPercent(item_.children)"
                  :value="item__.value"
                  :info-text="item__.info_text"
                  :is-child="true"
                  :is-rtl="true"
                  :isDecimal="isDecimal"
                )

</template>

<script>
import NAccordion from './n-accordion';
import NAccordionChartHeader from './n-accordion-chart-header';

export default {
  name: 'n-accordion-chart',

  components: {
    NAccordion,
    NAccordionChartHeader
  },

  props: {
    colors: {
      type: Array,
      default: () => []
    },

    items: {
      type: Array,
      default: () => []
    },

    isDecimal: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    defaultColors: [
      {
        value: '#e53935',
        children: [
          '#f44336',
          '#ef5350',
          '#e57373',
          '#ef9a9a',
          '#ffcdd2',
          '#ffebee',
        ]
      },
      {
        value: '#c0ca33',
        children: [
          '#cddc39',
          '#d4e157',
          '#dce775',
          '#e6ee9c',
          '#f0f4c3',
          '#f9fbe7',
        ]
      },
      {
        value: '#fb8c00',
        children: [
          '#ff9800',
          '#ffa726',
          '#ffb74d',
          '#ffcc80',
          '#ffe0b2',
          '#fff3e0',
        ]
      },
      {
        value: '#00897b',
        children: [
          '#009688',
          '#26a69a',
          '#4db6ac',
          '#80cbc4',
          '#b2dfdb',
          '#e0f2f1',
        ]
      },
      {
        value: '#8e24aa',
        children: [
          '#9c27b0',
          '#ab47bc',
          '#ba68c8',
          '#ce93d8',
          '#e1bee7',
          '#f3e5f5',
        ]
      },
      {
        value: '#3949ab',
        children: [
          '#3f51b5',
          '#5c6bc0',
          '#7986cb',
          '#9fa8da',
          '#c5cae9',
          '#e8eaf6',
        ]
      },
      {
        value: '#00acc1',
        children: [
          '#00bcd4',
          '#26c6da',
          '#4dd0e1',
          '#80deea',
          '#b2ebf2',
          '#e0f7fa',
        ]
      },
      {
        value: '#d81b60',
        children: [
          '#e91e63',
          '#ec407a',
          '#f06292',
          '#f48fb1',
          '#f8bbd0',
          '#fec4ec',
        ]
      },
      {
        value: '#1e88e5',
        children: [
          '#2196f3',
          '#42a5f5',
          '#64b5f6',
          '#90caf9',
          '#bbdefb',
          '#e3f2fd',
        ]
      },
    ],

    grayColors: [
      '#4D4D4D',
      '#5D5D5D',
      '#6C6C6C',
      '#7C7C7C',
      '#8B8B8B',
      '#9B9B9B',
      '#8B8B8B',
    ]
  }),

  methods: {
    getBarColor(index1, index2 = -1, index3 = -1) {
      const colors = this.colors && this.colors.length
        ? this.colors
        : this.defaultColors;

      let color = colors[index1 % colors.length];

      if (!color) {
        return '#ffffff';
      }

      if (index2 === -1 || !color.children || !color.children.length) {
        return color.value;
      }

      color = color.children[index2 % color.children.length];

      if (index3 === -1) {
        return color;
      }

      return this.grayColors[index3 % this.grayColors.length];
    },

    getMaxPercent(items) {
      return Math.max(...items.map(item => item.percent));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/n-accordion-chart.vue